import React, { useEffect, useState, useMemo } from 'react'
import ResponsiveDrawer from '../Drawer/drawer'
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Notification from "../AlertNotification/Message";
import { TextField } from '@mui/material';
import ListCard from '../../ReusableComponents/ListCard';
import { getCustomers } from '../../ReusableComponents/functions';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import debounce from 'lodash/debounce';

const SelectACustomer = () => {
    const drawerWidth = 240;
    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });
    const navigate = useNavigate();
    const [customers, setCustomers] = useState([]);
    const [filterCustomers, setFilterCustomers] = useState([]);
    const [searchVal, setSearchVal] = useState("");

    const fetchCustomers = async () => {
        const customersData = await getCustomers();
        setCustomers(customersData);
        setFilterCustomers(customersData);
    };

    useEffect(() => {
        fetchCustomers();
    }, []);

    // Memoize the debounce function to avoid recreating it on every render
    const debouncedFilter = useMemo(() => {
        return debounce((value, allCustomers) => {
            const filtered = allCustomers.filter((customer) =>
                (customer.StoreName || "").toLowerCase().includes(value.toLowerCase()) ||
                (customer.customerid || "").toLowerCase().includes(value.toLowerCase())
            );
            setFilterCustomers(filtered);
        }, 300);
    }, []);

    // Cleanup debounce on unmount
    useEffect(() => {
        return () => {
            debouncedFilter.cancel();
        };
    }, [debouncedFilter]);

    const handleFilterCustomers = (e) => {
        const val = e.target.value;
        setSearchVal(val);
        debouncedFilter(val, customers);
    };

    return (
        <div className="mx-4">
            <ResponsiveDrawer heading="Select A Customer - Create Order" />
            <Box
                sx={{
                    width: { sm: `calc(100% - ${drawerWidth}px)` },
                    ml: { sm: `${drawerWidth}px` },
                }}
                component="main"
            >
                <Toolbar />
                <div className="d-flex justify-content-between m-5 pt-5">
                    <Button variant="contained" startIcon={<ArrowBackIcon />} onClick={() => navigate('/OrderHistory')}>
                        Back
                    </Button>
                    <div>
                        <TextField 
                            id="outlined-basic" 
                            label="Search By Store Name" 
                            size='small' 
                            variant="outlined" 
                            value={searchVal}
                            onChange={handleFilterCustomers} 
                            sx={{ width: 280 }}
                        />
                    </div>
                </div>
                <div className='ms-5 ps-2 me-5 pe-2'>
                    <ListCard customers={filterCustomers} />
                </div>
            </Box>
            <Notification notify={notify} setNotify={setNotify} />
        </div>
    )
}

export default SelectACustomer